export default function AccordionInteraction(root: HTMLElement) {
  if (!root)
    return () => {
      console.log("root isn't init'd yet")
    }

  const accordions = root.querySelectorAll(
    '.accordion',
  ) as NodeListOf<HTMLElement>

  const accordionHandler = (e: Event) => {
    accordions.forEach((closing_accordion) => {
      closing_accordion.classList.remove('open')
    })
    const accordion_target = e.currentTarget as HTMLElement
    accordion_target.classList.toggle('open')
  }

  accordions.forEach((el) => el.addEventListener('click', accordionHandler))
}
